module.exports = __webpack_public_path__ + "static/media/case_03.e1cc4e13.jpg";